import { IResale } from '~/modules/resales/interfaces/IResale';
import { IUserAccess } from '~/modules/auth/interfaces/IUserAccess';
import { IParsedPermissions } from '../interfaces/IParsedPermissions';

import { getUserWhitelabelResale } from './getUserWhitelabelResale';
import { checkPermissions } from './checkPermissions';

export function parsePermissionsByUser(
  currentAccess: IUserAccess,
  resale: IResale
): IParsedPermissions {
  const checkedPermissions = checkPermissions(currentAccess, resale);

  const whiteLabelResale = getUserWhitelabelResale(resale);

  return {
    ALLOW_DASHBOARD_LIST: !!checkedPermissions.DASHBOARD.LIST,
    ALLOW_ACTIONS_CREATE: !!checkedPermissions.ACTIONS.CREATE,
    ALLOW_ACTIONS_LIST: !!checkedPermissions.ACTIONS.LIST,
    ALLOW_ACTIONS_UPDATE: !!checkedPermissions.ACTIONS.UPDATE,
    ALLOW_OFFERS_CREATE: !!checkedPermissions.OFFERS.CREATE,
    ALLOW_OFFERS_LIST: !!checkedPermissions.OFFERS.LIST,
    ALLOW_OFFERS_UPDATE: !!checkedPermissions.OFFERS.UPDATE,
    ALLOW_OFFER_PURCHASES_INFORM_ACTION:
      !!checkedPermissions.OFFER_PURCHASES.INFORM_ACTION,
    ALLOW_OFFER_PURCHASES_LIST: !!checkedPermissions.OFFER_PURCHASES.LIST,
    ALLOW_OFFER_PURCHASES_SEND_CREDENTIALS:
      !!checkedPermissions.OFFER_PURCHASES.SEND_CREDENTIALS,
    ALLOW_OFFER_PURCHASES_UPDATE: !!checkedPermissions.OFFER_PURCHASES.UPDATE,
    ALLOW_LEADS_ARCHIVE: !!checkedPermissions.LEADS.ARCHIVE,
    ALLOW_LEADS_CREATE: !!checkedPermissions.LEADS.CREATE,
    ALLOW_LEADS_DEFINE_RESPONSIBLE_USER:
      !!checkedPermissions.LEADS.DEFINE_RESPONSIBLE_USER,
    ALLOW_LEADS_EXPORT: !!checkedPermissions.LEADS.EXPORT,
    ALLOW_LEADS_IMPORT: !!checkedPermissions.LEADS.IMPORT,
    ALLOW_LEADS_INFORM_ACTION: !!checkedPermissions.LEADS.INFORM_ACTION,
    ALLOW_LEADS_LIST: !!checkedPermissions.LEADS.LIST,
    ALLOW_LEADS_UPDATE: !!checkedPermissions.LEADS.UPDATE,
    ALLOW_PERMISSIONS_GROUPS_CREATE:
      !!checkedPermissions.PERMISSIONS_GROUPS.CREATE,
    ALLOW_PERMISSIONS_GROUPS_LIST: !!checkedPermissions.PERMISSIONS_GROUPS.LIST,
    ALLOW_PERMISSIONS_GROUPS_UPDATE:
      !!checkedPermissions.PERMISSIONS_GROUPS.UPDATE,
    ALLOW_RESALES_CREATE: !!checkedPermissions.RESALES.CREATE,
    ALLOW_RESALES_INFORM_ACTION: !!checkedPermissions.RESALES.INFORM_ACTION,
    ALLOW_RESALES_LIST: !!checkedPermissions.RESALES.LIST,
    ALLOW_RESALES_UPDATE: !!checkedPermissions.RESALES.UPDATE,
    ALLOW_RETENTIONS_LIST: !!checkedPermissions.RETENTIONS.LIST,
    ALLOW_RETENTIONS_APPROVE_CANCELATION:
      !!checkedPermissions.RETENTIONS.APPROVE_CANCELATION,
    ALLOW_RETENTIONS_REQUEST_CANCELATION:
      !!checkedPermissions.RETENTIONS.REQUEST_CANCELATION,
    ALLOW_RETENTIONS_REACTIVATE_SUBSCRIPTION:
      !!checkedPermissions.RETENTIONS.REACTIVATE_SUBSCRIPTION,
    ALLOW_RETENTIONS_RECORD_CREATE:
      !!checkedPermissions.RETENTIONS.RECORD_CREATE,
    ALLOW_SUBSCRIBERS_INFORM_ACTION:
      !!checkedPermissions.SUBSCRIBERS.INFORM_ACTION,
    ALLOW_SUBSCRIBERS_LIST: !!checkedPermissions.SUBSCRIBERS.LIST,
    ALLOW_SUBSCRIBERS_EXPORT: !!checkedPermissions.SUBSCRIBERS.EXPORT,
    ALLOW_SUBSCRIBERS_UPDATE: !!checkedPermissions.SUBSCRIBERS.UPDATE,
    ALLOW_USERS_CREATE: !!checkedPermissions.USERS.CREATE,
    ALLOW_USERS_LIST: !!checkedPermissions.USERS.LIST,
    ALLOW_USERS_UPDATE: !!checkedPermissions.USERS.UPDATE,
    ALLOW_USERS_UPDATE_STATUS: !!checkedPermissions.USERS.UPDATE_STATUS,
    ALLOW_ARCHIVED_LEADS_REACTIVATE:
      !!checkedPermissions.LEADS.REACTIVATE_ARCHIVED,
    ALLOW_HELP_LIST: !!checkedPermissions.HELP.LIST,
    ALLOW_HELP_INFORM_ACTION: !!checkedPermissions.HELP.INFORM_ACTION,
    ALLOW_SUBSCRIBERS_SUBSCRIPTION_DETAILS:
      !!checkedPermissions.SUBSCRIBERS.SUBSCRIPTION_DETAILS,
    ALLOW_SUBSCRIBERS_CONSUMPTION_DETAILS:
      !!checkedPermissions.SUBSCRIBERS.CONSUMPTION_DETAILS,
    ALLOW_RESALES_BLOCK: !!checkedPermissions.RESALES.BLOCK,
    ALLOW_RESALES_CANCEL: !!checkedPermissions.RESALES.CANCEL,
    ALLOW_RESALES_ACTIVE: !!checkedPermissions.RESALES.ACTIVE,
    ALLOW_COURSES_LIST:
      !!resale?._id && !!whiteLabelResale.adminPortalCoursesShowcaseId,
    ALLOW_OPERATING_AREAS_LIST: !!checkedPermissions.OPERATING_AREAS.LIST,
    ALLOW_OPERATING_AREAS_CREATE: !!checkedPermissions.OPERATING_AREAS.CREATE,
    ALLOW_OPERATING_AREAS_UPDATE: !!checkedPermissions.OPERATING_AREAS.UPDATE,
    ALLOW_OPERATING_AREAS_UPDATE_STATUS:
      !!checkedPermissions.OPERATING_AREAS.UPDATE_STATUS,
    ALLOW_FINANCIAL_TITLES_LIST: !!checkedPermissions.FINANCIAL_TITLES.LIST,
    ALLOW_FINANCIAL_TITLES_EXPORT: !!checkedPermissions.FINANCIAL_TITLES.EXPORT,
    ALLOW_SUBSCRIBERS_CREATE_SYSTEM_SUBSCRIPTION:
      !!checkedPermissions.SUBSCRIBERS.CREATE_SYSTEM_SUBSCRIPTION,
    ALLOW_SUBSCRIBERS_CREATE_SYSTEM_SUBSCRIPTION_AMENDMENT:
      !!checkedPermissions.SUBSCRIBERS.CREATE_SYSTEM_SUBSCRIPTION_AMENDMENT,
    ALLOW_SUBSCRIBERS_CREATE_RENTAL_SUBSCRIPTION:
      !!checkedPermissions.SUBSCRIBERS.CREATE_RENTAL_SUBSCRIPTION,
    ALLOW_SUBSCRIBERS_CREATE_RENTAL_SUBSCRIPTION_AMENDMENT:
      !!checkedPermissions.SUBSCRIBERS.CREATE_RENTAL_SUBSCRIPTION_AMENDMENT,
    ALLOW_FINANCIAL_PAYOUT_LIST: !!checkedPermissions.FINANCIAL_PAYOUT.LIST,
    ALLOW_FINANCIAL_PAYOUT_CREATE: !!checkedPermissions.FINANCIAL_PAYOUT.CREATE,
    ALLOW_FINANCIAL_PAYOUT_DETAILS:
      !!checkedPermissions.FINANCIAL_PAYOUT.DETAILS,
  };
}
